import { AuthToken } from "../../models";
import { AuthActions, AuthActionTypes } from "../actions";
import { AuthService } from "../../services";

export interface State {
  error: any;
  loading: boolean;
  username: string;
  token: AuthToken | null;
  jwt: string | null;
}

export const initialState = {
  error: null,
  loading: false,
  username: null,
  token: null,
  jwt: null
};

export function reducer(state = initialState, action: AuthActions): State {
  switch (action.type) {
    case AuthActionTypes.Login: {
      return {
        ...state,
        error: null,
        loading: true
      };
    }
    case AuthActionTypes.LoginFailure: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
  case AuthActionTypes.LoginSuccess: {
      const decodedToken = AuthService.jwtDecode(action.payload.jwt);
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("jwt", action.payload.jwt);
      localStorage.setItem("username", action.payload.username)
      const tk: AuthToken = {
        token: action.payload.token,
        jwt: action.payload.jwt,
        expiresIn: decodedToken.exp - decodedToken.nbf,
        expiredAt: decodedToken.exp
      };
      return {
        ...state,
        error: null,
        loading: false,
        username: action.payload.username,
        token: tk,
        jwt: tk.jwt
      };
    }
    case AuthActionTypes.Logout:
      return initialState;
    case AuthActionTypes.LoginReset: {
      return initialState;
    }
    case AuthActionTypes.ReloadToken: {
      const token = localStorage.getItem("token");
      const jwt = localStorage.getItem("jwt");
      const username = localStorage.getItem("username")
      if (!token || !jwt) {
        return {
          ...state
        };
      }
      const decodedToken = AuthService.jwtDecode(jwt);

      const tk: AuthToken = {
        token: token,
        jwt: jwt,
        expiresIn: decodedToken.exp - decodedToken.nbf,
        expiredAt: decodedToken.exp
      };
      return {
        ...state,
        error: null,
        loading: false,
        username: username,
        token: tk
      };
    }
    default:
      return state;
  }
}

export const getError = (state: State) => state.error;
export const getIsAuthenticated = (state: State) => {
  if (!state.token) {
    return false;
  }
  const now = new Date().getTime() / 1000;
  const expiredAt = state.token.expiredAt;
  return expiredAt > now;
};
export const getLoading = (state: State) => state.loading;
export const getToken = (state: State) => state.token;
export const getJwtToken = (state: State) => state.jwt;
export const getUsername = (state: State) => state.username;
